<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="md"
      ok-only
      :ok-title="$t('Send')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="submit"
      @hidden="reset"
    >
      <template #modal-title="{}">
        <span>
          {{ $t("Account send unsent messages") }}
        </span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Date range')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Date range')"
                rules="required"
              >
                <date-picker
                  v-model="date"
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Date range')"
                  type="date"
                  custom-input=".date-time-autochat"
                  color="#28c76f"
                  range
                />
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <feather-icon icon="CalendarIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    class="date-time-autochat"
                    style="direction: ltr"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Message count')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Message count')"
                vid="limit"
              >
                <b-form-input
                  id="limit"
                  v-model="limit"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Message count')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("Send") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../common/mixins/form'

export default {
  name: 'AccountsSendUnsetMessagesModal',
  components: {

  },
  mixins: [EditFormLayoutMixin, EditModalMixin],
  props: {
    id: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      modalName: 'accounts-send-unsent-messages-modal',
      date: '',
      limit: '',
    }
  },
  methods: {
    submit(bvModalEvent = null) {
      if (bvModalEvent) bvModalEvent.preventDefault()
      this.$refs.form.validate().then(success => {
        if (success) {
          this.sendUnsentMessages()
        }
      })
    },
    sendUnsentMessages(confirm = false) {
      const data = { date: this.date, limit: this.limit, confirm }
      this.submitSpinner = true
      this.$http.post(`accounts/${this.id}/send-unsent-messages`, data).then(({ message }) => {
        this.submitSpinner = false
        if (confirm) {
          this.showSuccessNotification(message)
          this.$bvModal.hide(this.modalName)
          this.reset()
        } else {
          this.showConfirmDialog({ text: message }).then(() => {
            this.sendUnsentMessages(true)
          })
        }
      }).catch(() => {
        this.submitSpinner = false
      })
    },
    reset() {
      this.date = ''
      this.limit = ''
    },
  },
}
</script>

<style scoped>

</style>
